/* eslint-disable max-lines */
import { ContextStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import * as React from 'react';

import { TravelerSelector } from '@shared-ui/lodging-property-offers';

import { CurrentHotelStore } from 'stores/current-hotel-store';

import { RoomInput } from 'src/common/__generated__/api';
import { SharedUiWrapperProps, withSharedUiPropertyOffers } from '../offers/shared-ui-property-offers';

export interface GroupInput extends RoomInput {
  petsIncluded?: boolean;
}

export interface TravelersInput {
  rooms: GroupInput[];
}

interface TravelerSelectorWrapperProps extends SharedUiWrapperProps {
  context?: ContextStore;
  currentHotel?: CurrentHotelStore;
}

const TravelersSelectorWrapper: React.FC<TravelerSelectorWrapperProps> = inject('currentHotel')(({ inputs, currentHotel }) => {
  const ref = React.useRef(null);
  if (!currentHotel) {
    return null;
  }
  const { offerSearchData } = currentHotel;
  const { adults, children, petsIncluded } = offerSearchData;

  const adultCount = Number(adults ?? 1);
  const childCount = children ? children.split(',').length : 0;

  const initialTravelerData = {
    totalGuestCount: adultCount + childCount,
    petsIncluded: petsIncluded ?? false,
    rooms: currentHotel?.searchCriteria.rooms ?? [],
  };

  const mockTranslations = {
    travelers: 'hotels.roomPicker.roomSummary.singleUnit',
    pets: 'hotels.roomPicker.roomSummary.singleUnit.withPets',
    travelersLabel: 'hotels.roomPicker.title',
  };

  const updateStoreWithTravelerUrlData = (dataForStore: TravelersInput, petsIncluded: boolean) => {
    const { rooms } = dataForStore;
    const adults = rooms?.reduce((count: number, room: RoomInput) => count + (room.adults || 0), 0) ?? 0;
    const children = rooms?.flatMap((room, roomIndex) => room.children?.map(({ age }) => `${roomIndex + 1}_${age}`) ?? []) ?? [];

    currentHotel?.setOfferData({ adults, children: children.join(','), petsIncluded });
  };

  return (
    <TravelerSelector
      inputs={inputs}
      initalTravelerData={initialTravelerData}
      translations={mockTranslations}
      updateStoreWithTravelerUrlData={updateStoreWithTravelerUrlData}
      triggerRef={ref}
    />
  );
});
TravelersSelectorWrapper.displayName = 'TravelersSelectorWrapper';
export const SharedUiTravelersSelectorWrapper = withSharedUiPropertyOffers(TravelersSelectorWrapper);
